import { createFileRoute } from '@tanstack/react-router';
import KoboPage from '@/pages/static/KoboPage';

export const Route = createFileRoute('/kobo')({
  component: KoboPage,
});
